export default __webpack_public_path__ + "static/media/mobilkit_wrapper.f6fad93a.svg";